import React, {useEffect, useState} from 'react';
import {createPortal} from 'react-dom';
import classnames from 'classnames/bind';
import PropTypes from 'prop-types';
import ReactPlayer from 'react-player/youtube';
import { Icon } from '../Icon';
import { isMobile } from '../../../ui-v1/utils/dimensions';
import youtubeImageSrc from '../../../ui-v1/assets/images/youtube.png';
import styles from './YoutubePlayer.css';

const cx = classnames.bind(styles);

const YoutubePlayer = ({url, className, placeholderImageUrl}) => {
    const classes = cx({
        placeholder: true,
        [className]: Boolean(className)
    });
    const [isOpen, setIsOpen] = useState(false);
    const [isPlaying, setIsPlaying] = useState(false);

    useEffect(() => {
        if (isOpen) {
            setIsPlaying(true);
        }
    }, [isOpen]);

    const handleOpenPlayer = () => {
        setIsOpen(true);
    };
    const closePlayer = () => {
        setIsPlaying(false);

        setTimeout(() => {
            setIsOpen(false);
        }, 0);
    };

    const renderVideo = () => (
        <div className={styles.wrapper}>
            <div className={styles.playerWrapper}>
                <ReactPlayer
                    className={styles.player}
                    url={url}
                    playsinline
                    width='100%'
                    height='100%'
                    playing={isPlaying}
                    controls
                />
                <Icon
                    name='close'
                    onClick={closePlayer}
                    className={styles.iconClose}
                />
            </div>
        </div>
    )

    const renderVideoByDimensions = () => {
        if (isMobile()) {
            return renderVideo();
        }

        return createPortal(renderVideo(), document.body);
    }

    return (
        <div
            className={classes}
            onClick={handleOpenPlayer}
        >
            {isOpen
                ? renderVideoByDimensions()
                : (
                    <div className={styles.placeholderWrapper}>
                        <img
                            src={placeholderImageUrl}
                            className={styles.placeholderImage}
                            alt='placeholder'
                            loading='lazy'
                        />
                        <img
                            src={youtubeImageSrc}
                            className={styles.youtubeImage}
                            alt='youtube'
                            loading='lazy'
                        />
                    </div>
                )
            }
        </div>
    );
};

YoutubePlayer.propTypes = {
    url: PropTypes.string.isRequired,
    placeholderImageUrl: PropTypes.string,
    className: PropTypes.string
};

export {
    YoutubePlayer
};
